import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import Navigation from './components/Navigation';
import AutoCrop from './components/AutoCrop';
import Campaign from './components/Campaign';

function App() {
  return (
    <Router>
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)',
          py: 4
        }}
      >
        <Navigation />
        <Routes>
          <Route path="/" element={<AutoCrop />} />
          <Route path="/campaigns" element={<Campaign />} />
        </Routes>
      </Box>
    </Router>
  );
}

export default App;